bindFranchiseFitPlanControls();

function bindFranchiseFitPlanControls() {
    $(document).off('click.franchiseFitPlanAddBrands', '#franchise-fit-plan .add-brands-button');
    $(document).on('click.franchiseFitPlanAddBrands', '#franchise-fit-plan .add-brands-button', function () {
        $('.add-brands-button').addClass('d-none');
        $('.show-expanded').removeClass('d-none');
        $('.search-brand input').focus();
        $('.add-brands-column').addClass('expanded');
    });

    $(document).off('click.franchiseFitPlanCancelBrands', '#franchise-fit-plan .cancel-brands-button');
    $(document).on('click.franchiseFitPlanCancelBrands', '#franchise-fit-plan .cancel-brands-button', function () {
        $('.add-brands-button').removeClass('d-none');
        $('.show-expanded').addClass('d-none');
        $('.add-brands-column').removeClass('expanded');
    });

    $(document).off('click.franchiseFitPlanViewMore', '#franchise-fit-plan tr.view-more-row');
    $(document).on('click.franchiseFitPlanViewMore', '#franchise-fit-plan tr.view-more-row', function () {
        const tableParent = $(this).closest('.main-fit-plan-tables-js');
        const viewMore = $(this).attr('trigger');
        const rows = tableParent.find(`tr[view_more=${viewMore}]`);
        const viewMoreRows = tableParent.find('.view-more-row[trigger=' + viewMore + ']');
        if (rows.hasClass('d-none')) {
            rows.removeClass('d-none');
            viewMoreRows.find('td').each(function () {
                if ($(this).text().includes('All')) {
                    $(this).text($(this).text().replace('All', 'Less'));
                }
                const arrows = $(this).find('.fa-arrow-down');
                if (arrows.length) {
                    arrows.removeClass('fa-arrow-down').addClass('fa-arrow-up');
                }
                const clickToExpand = $(this).find('.click-to-expand');
                if (clickToExpand.length) {
                    clickToExpand.text(clickToExpand.text().replace('Expand', 'Collapse'));
                }
            })
        } else {
            rows.addClass('d-none');
            viewMoreRows.find('td').each(function () {
                if ($(this).text().includes('Less')) {
                    $(this).text($(this).text().replace('Less', 'All'));
                }
                const arrows = $(this).find('.fa-arrow-up');
                if (arrows.length) {
                    arrows.removeClass('fa-arrow-up').addClass('fa-arrow-down');
                }
                const clickToExpand = $(this).find('.click-to-expand');
                if (clickToExpand.length) {
                    clickToExpand.text(clickToExpand.text().replace('Collapse', 'Expand'));
                }
            })
        }
    });
}

$(document).on('turbo:load', function () {

    $('#franchise-fit-plan .brand-extra-filter-drop-down').click(function () {
        const brandsPopout = $(this).closest('.add-brands-column');
        const extraFilterContainer = brandsPopout.find('.brand-extra-filters');
        extraFilterContainer.hasClass('d-none') ? extraFilterContainer.removeClass('d-none') : extraFilterContainer.addClass('d-none');
    });
    // ---------------------------------------------------------------------------------------------------------------------
    const sortByScoreCheckBox = $('#franchise-fit-plan .sort-by-score-check-box');
    const brandsTable = $('#franchise-fit-plan .search-brand-table-holder table');
    let brandsTableItems = $('#franchise-fit-plan .search-brand-table-holder tr');
    sortByScoreCheckBox.change(function () {
        if (sortByScoreCheckBox.find('input[type=checkbox]').is(':checked')) {
            const brandsTableItemsCopy = brandsTableItems.slice();
            const scoreSortedItems = brandsTableItemsCopy.sort(function (a, b) {
                const indexA = parseInt($(a).attr('sorted_by_score_index'));
                const indexB = parseInt($(b).attr('sorted_by_score_index'));
                return (indexA < indexB) ? -1 : (indexA > indexB) ? 1 : 0;
            });

            scoreSortedItems.detach().appendTo(brandsTable);
        } else {
            brandsTableItems.detach().appendTo(brandsTable);
        }
    });
    // -----------------------------------------------------------------------------------------------------------------
    const favoriteBrandsFilter = $('#franchise-fit-plan .favorite-brands-filter');
    // Keeping track of removed brands for reattachment later
    const removedBrands = []
    // Borrowing brands table from above (23)
    // Borrowing brands table items from above (24)
    favoriteBrandsFilter.change(function () {
        const checkbox = $(this).find("input[type='checkbox']")
        // If checkbox is checked, hide brands that do not have favorite attribute
        if (checkbox.is(':checked')) {
            brandsTableItems.each(index => {
                const brandCard = brandsTableItems[index]
                if ($(brandCard).attr('favorite') === 'false') {
                    removedBrands.push($(brandCard))
                    $(brandCard).detach()
                }
            })
        } else {
            // If checkbox is not checked, show all brands and call filterBrands again to reapply other filters
            removedBrands.forEach((brand) => {
                brand.appendTo(brandsTable)
            })
            filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal)
        }
    })
    // -----------------------------------------------------------------------------------------------------------------
    const filterContainer = $('#franchise-fit-plan .brand-extra-filters');
    // Borrowing brands table items from above (24)
    const brandNameFilter = $('#franchise-fit-plan .search-brand').find('#filter-brand-name');
    const businessCatFilter = filterContainer.find('#filter-business-cat');
    const netWorthFilter = filterContainer.find('#filter-net-worth');
    const liquidCapFilter = filterContainer.find('#filter-liquid-cap');
    const homeBasedFilter = filterContainer.find('#filter-home-based');
    const operatorFilter = filterContainer.find('#filter-operator');
    const hoursFilter = filterContainer.find('#filter-hours');
    const unitsOpenFilter = filterContainer.find('#filter-units-open');
    const allInFilter = filterContainer.find('#filter-all-in');
    const employeesFilter = filterContainer.find('#filter-employees');
    const employeeTypeFilter = filterContainer.find('#filter-employee-type');
    const salesSkillsFilter = filterContainer.find('#filter-sales-skills');
    const nonGlamorousFilter = filterContainer.find('#filter-non-glamorous');
    const timeToOpenFilter = filterContainer.find('#filter-time-to-open');
    const recentlyAddedFilter = filterContainer.find('#filter-recently-added');

    let brandNameVal = null;
    let matchingBrandIds = null; // null = no keyword filter active; Set of brand ID strings when active
    let businessCatVal = null;
    let netWorthVal = null;
    let liquidCapVal = null;
    let regStateVal = null;
    let homeBasedVal = null;
    let operatorVal = null;
    let hoursVal = null;
    let unitsOpenVal = null;
    let allInVal = null;
    let employeesVal = null;
    let employeeTypeVal = null;
    let salesSkillsVal = null;
    let nonGlamorousVal = null;
    let timeToOpenVal = null;
    // SBA Franchise Directory filter (SD-2443). Read directly from this closure inside
    // filterBrands rather than threaded as a positional arg through every call site.
    let sbaVal = null;
    let recentlyAddedVal = null;

    // Titleize a state
    const titleize = (state) => {
        const statePretty = state.split('_');
        for (let i = 0; i < statePretty.length; i++) {
            const word = statePretty[i]
            statePretty[i] = word.split('')[0].toUpperCase() + word.slice(1);
        }
        return statePretty.join(' ')
    }

    const businessCatCheck = (businessCatVal, brandCard, brandCardCL, parentRow) => {
        const hiddenCat = parentRow.find('.category')
        if (businessCatVal) {
            if (businessCatVal !== brandCard.getAttribute('category')) brandCardCL.add('d-none')
            hiddenCat.removeClass('d-none')
        } else hiddenCat.addClass('d-none')
    }

    // The option text is a NET_WORTH_OPTIONS/LIQUIDITY_RETIREMENT_OPTIONS bracket like
    // "$100,000 - $200,000", or the open-ended top bracket "$3,000,000+". Parse both
    // bounds so a selected bracket only matches brands actually priced within it.
    const currencyRangeBounds = (rangeText) => {
        const numbers = rangeText.match(/[\d,]+/g).map((n) => Number(n.replace(/,/g, '')));
        const isOpenEnded = rangeText.trim().endsWith('+');
        return { min: numbers[0], max: isOpenEnded ? Infinity : numbers[1] };
    }

    const netWorthCheck = (netWorthVal, brandCard, brandCardCL, parentRow) => {
        const hiddenNetWorth = parentRow.find('.net-worth')
        if (netWorthVal) {
            const { min, max } = currencyRangeBounds(netWorthVal);
            const brandNetWorth = Number(brandCard.getAttribute('net_worth'));
            if (brandNetWorth < min || brandNetWorth > max) brandCardCL.add('d-none')
            hiddenNetWorth.removeClass('d-none')
        } else hiddenNetWorth.addClass('d-none')
    }

    const liquidCapCheck = (liquidCapVal, brandCard, brandCardCL, parentRow) => {
        const hiddenLiquidCap = parentRow.find('.liquid-cap');
        if (liquidCapVal) {
            const { min, max } = currencyRangeBounds(liquidCapVal);
            const brandLiquidCap = Number(brandCard.getAttribute('liquid_capital'));
            if (brandLiquidCap < min || brandLiquidCap > max) brandCardCL.add('d-none')
            hiddenLiquidCap.removeClass('d-none')
        } else hiddenLiquidCap.addClass('d-none')
    }

    const regStatesCheck = (regStateVal, brandCard, brandCardCL, parentRow) => {
        const hiddenStateReg = parentRow.find('.state-reg')
        const regStates = brandCard.getAttribute('registration_states');
        if (regStateVal) {
            const regStatesObj = JSON.parse(regStates.split('=>').join(':'))
            if (regStatesObj[regStateVal] !== 'Registered' && regStatesObj[regStateVal] !== 'Deferred - Taking Leads') brandCardCL.add('d-none')
            const prettyState = titleize(regStateVal)
            hiddenStateReg.removeClass('d-none')
            hiddenStateReg.find('.registration-states-span').text(`${prettyState} -- ${regStatesObj[regStateVal]}`)
        } else if (!regStateVal) hiddenStateReg.addClass('d-none')
        // Brand Name filter — checked via backend BrandsSearch result
        if (matchingBrandIds !== null && !matchingBrandIds.has(String(brandCard.getAttribute('brand_id')))) brandCardCL.add('d-none')
    }

    const homeBasedCheck = (homeBasedVal, brandCard, brandCardCL, parentRow) => {
        const hiddenHomeBased = parentRow.find('.home-based');
        if (homeBasedVal) {
            const brandHomeBased = brandCard.getAttribute('home_based');
            if (brandHomeBased !== homeBasedVal) brandCardCL.add('d-none');
            hiddenHomeBased.removeClass('d-none');
        } else hiddenHomeBased.addClass('d-none');
    }

    const operatorCheck = (operatorVal, brandCard, brandCardCL, parentRow) => {
        const hiddenOperator = parentRow.find('.operator');
        if (operatorVal) {
            const brandOperator = brandCard.getAttribute('operator');
            if (!brandOperator || !brandOperator.includes(operatorVal)) brandCardCL.add('d-none');
            hiddenOperator.removeClass('d-none');
        } else hiddenOperator.addClass('d-none');
    }

    const hoursCheck = (hoursVal, brandCard, brandCardCL, parentRow) => {
        const hiddenHours = parentRow.find('.hours');
        if (hoursVal) {
            const brandHours = brandCard.getAttribute('hours');
            if (!brandHours || !brandHours.includes(hoursVal)) brandCardCL.add('d-none');
            hiddenHours.removeClass('d-none');
        } else hiddenHours.addClass('d-none');
    }

    const unitsOpenCheck = (unitsOpenVal, brandCard, brandCardCL, parentRow) => {
        const hiddenUnitsOpen = parentRow.find('.units-open');
        if (unitsOpenVal) {
            const brandUnits = parseInt(brandCard.getAttribute('units_open')); // Assuming data-attribute is integer
            if (isNaN(brandUnits)) brandCardCL.add('d-none');
            else if (unitsOpenVal === '0-25' && !(brandUnits >= 0 && brandUnits <= 25)) brandCardCL.add('d-none');
            else if (unitsOpenVal === '26-50' && !(brandUnits >= 26 && brandUnits <= 50)) brandCardCL.add('d-none');
            else if (unitsOpenVal === '51-75' && !(brandUnits >= 51 && brandUnits <= 75)) brandCardCL.add('d-none');
            else if (unitsOpenVal === '76-100' && !(brandUnits >= 76 && brandUnits <= 100)) brandCardCL.add('d-none');
            else if (unitsOpenVal === 'Over 100' && !(brandUnits > 100)) brandCardCL.add('d-none');
            hiddenUnitsOpen.removeClass('d-none');
        } else hiddenUnitsOpen.addClass('d-none');
    }

    const allInCheck = (allInVal, brandCard, brandCardCL, parentRow) => {
        const hiddenAllIn = parentRow.find('.all-in');
        if (allInVal) {
            const avgAllIn = parseInt(brandCard.getAttribute('avg_all_in'));
            if (isNaN(avgAllIn)) brandCardCL.add('d-none');
            else if (allInVal === 'Under $100,000' && !(avgAllIn < 200000)) brandCardCL.add('d-none');
            else if (allInVal === '$100,000 - $250,000' && !(avgAllIn >= 100000 && avgAllIn <= 250000)) brandCardCL.add('d-none');
            else if (allInVal === '$250,000 - $500,000' && !(avgAllIn >= 250000 && avgAllIn <= 500000)) brandCardCL.add('d-none');
            else if (allInVal === '$500,000+' && !(avgAllIn > 500000)) brandCardCL.add('d-none');
            hiddenAllIn.removeClass('d-none');
        } else hiddenAllIn.addClass('d-none');
    }

    const employeesCheck = (employeesVal, brandCard, brandCardCL, parentRow) => {
        const hiddenEmployees = parentRow.find('.employees');
        if (employeesVal) {
            const brandEmployees = brandCard.getAttribute('employees');
            if (brandEmployees !== employeesVal) brandCardCL.add('d-none');
            hiddenEmployees.removeClass('d-none');
        } else hiddenEmployees.addClass('d-none');
    }

    const employeeTypeCheck = (employeeTypeVal, brandCard, brandCardCL, parentRow) => {
        const hiddenEmployeeType = parentRow.find('.employee-type');
        if (employeeTypeVal) {
            const brandEmployeeType = brandCard.getAttribute('employee_type');
            if (brandEmployeeType !== employeeTypeVal) brandCardCL.add('d-none');
            hiddenEmployeeType.removeClass('d-none');
        } else hiddenEmployeeType.addClass('d-none');
    }

    const salesSkillsCheck = (salesSkillsVal, brandCard, brandCardCL, parentRow) => {
        const hiddenSalesSkills = parentRow.find('.sales-skills');
        if (salesSkillsVal) {
            const brandSalesSkills = brandCard.getAttribute('sales_skills');
            if (brandSalesSkills !== salesSkillsVal) brandCardCL.add('d-none');
            hiddenSalesSkills.removeClass('d-none');
        } else hiddenSalesSkills.addClass('d-none');
    }

    const nonGlamorousCheck = (nonGlamorousVal, brandCard, brandCardCL, parentRow) => {
        const hiddenNonGlamorous = parentRow.find('.non-glamorous');
        if (nonGlamorousVal) {
            const brandNonGlamorous = brandCard.getAttribute('non_glamorous');
            if (brandNonGlamorous !== nonGlamorousVal) brandCardCL.add('d-none');
            hiddenNonGlamorous.removeClass('d-none');
        } else hiddenNonGlamorous.addClass('d-none');
    }

    const timeToOpenCheck = (timeToOpenVal, brandCard, brandCardCL, parentRow) => {
        const hiddenTimeToOpen = parentRow.find('.time-to-open');
        if (timeToOpenVal) {
            const brandTimeToOpen = brandCard.getAttribute('time_to_open');
            if (brandTimeToOpen !== timeToOpenVal) brandCardCL.add('d-none');
            hiddenTimeToOpen.removeClass('d-none');
        } else hiddenTimeToOpen.addClass('d-none');
    }

    const sbaCheck = (sbaVal, brandCard, brandCardCL, parentRow) => {
        const hiddenSba = parentRow.find('.sba');
        if (sbaVal) {
            const brandSba = brandCard.getAttribute('sba_registered');
            if (brandSba !== sbaVal) brandCardCL.add('d-none');
            hiddenSba.removeClass('d-none');
        } else hiddenSba.addClass('d-none');
    }

    const recentlyAddedCheck = (recentlyAddedVal, brandCard, brandCardCL, parentRow) => {
        const hiddenRecentlyAdded = parentRow.find('.recently-added');
        if (recentlyAddedVal) {
            const joinedInventoryAt = brandCard.getAttribute('joined_inventory_at');
            const joinedDate = joinedInventoryAt ? new Date(joinedInventoryAt) : null;
            const cutoffDate = new Date();
            cutoffDate.setDate(cutoffDate.getDate() - parseInt(recentlyAddedVal));
            if (!joinedDate || joinedDate < cutoffDate) brandCardCL.add('d-none');
            hiddenRecentlyAdded.removeClass('d-none');
        } else hiddenRecentlyAdded.addClass('d-none');
    }

    const filterBrands = (businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal) => {

        brandsTableItems.removeClass('d-none');

        brandsTableItems.each(index => {
            const brandCard = brandsTableItems[index]
            const brandCardCL = brandCard.classList
            const parentRow = $(brandCard)
            const hiddenInfo = parentRow.find('.extra-filtered-information')

            if (businessCatVal || netWorthVal || liquidCapVal || regStateVal || homeBasedVal || operatorVal || hoursVal || unitsOpenVal || allInVal || employeesVal || employeeTypeVal || salesSkillsVal || nonGlamorousVal || timeToOpenVal || sbaVal || recentlyAddedVal) hiddenInfo.removeClass('d-none');
            else hiddenInfo.addClass('d-none')

            // Business Category filter
            businessCatCheck(businessCatVal, brandCard, brandCardCL, parentRow);
            // Net Worth filter
            netWorthCheck(netWorthVal, brandCard, brandCardCL, parentRow);
            // Liquid Cap filter
            liquidCapCheck(liquidCapVal, brandCard, brandCardCL, parentRow);
            // Reg State filter
            regStatesCheck(regStateVal, brandCard, brandCardCL, parentRow);
            // Home based
            homeBasedCheck(homeBasedVal, brandCard, brandCardCL, parentRow);
            // Operator
            operatorCheck(operatorVal, brandCard, brandCardCL, parentRow);
            // Hours
            hoursCheck(hoursVal, brandCard, brandCardCL, parentRow);
            // Units Open
            unitsOpenCheck(unitsOpenVal, brandCard, brandCardCL, parentRow);
            // All In
            allInCheck(allInVal, brandCard, brandCardCL, parentRow);
            // Employees
            employeesCheck(employeesVal, brandCard, brandCardCL, parentRow);
            // Employee Type
            employeeTypeCheck(employeeTypeVal, brandCard, brandCardCL, parentRow);
            // Sales Skills
            salesSkillsCheck(salesSkillsVal, brandCard, brandCardCL, parentRow);
            // Non Glamorous
            nonGlamorousCheck(nonGlamorousVal, brandCard, brandCardCL, parentRow);
            // Time to Open
            timeToOpenCheck(timeToOpenVal, brandCard, brandCardCL, parentRow);
            // SBA Approved (sbaVal read from the enclosing closure)
            sbaCheck(sbaVal, brandCard, brandCardCL, parentRow);
            // Recently Added
            recentlyAddedCheck(recentlyAddedVal, brandCard, brandCardCL, parentRow);
        })
    }

    $(document).on('change', '#filter-business-cat', function () {
        businessCatVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-net-worth', function () {
        netWorthVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-liquid-cap', function () {
        liquidCapVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-state-reg', function () {
        regStateVal = $(this).val()
        // Break 'registration' off state
        regStateVal = regStateVal?.split('_').splice(1, regStateVal.length - 1).join('_');
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-home-based', function () {
        homeBasedVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-operator', function () {
        operatorVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-hours', function () {
        hoursVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-units-open', function () {
        unitsOpenVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-all-in', function () {
        allInVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-employees', function () {
        employeesVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });

    $(document).on('change', '#filter-employee-type', function () {
        employeeTypeVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-sales-skills', function () {
        salesSkillsVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-non-glamorous', function () {
        nonGlamorousVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-time-to-open', function () {
        timeToOpenVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-recently-added', function () {
        recentlyAddedVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    $(document).on('change', '#filter-sba', function () {
        sbaVal = $(this).val()
        filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal)
    });
    let brandKeywordTimeout;
    brandNameFilter.on('input', function () {
        clearTimeout(brandKeywordTimeout);
        const keyword = $(this).val().trim();

        if (!keyword) {
            matchingBrandIds = null;
            filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal);
            return;
        }

        brandKeywordTimeout = setTimeout(() => {
            const clientId = document.querySelector('.search-brand-table-holder')?.dataset?.clientId;
            fetch(`/franchise_fit_plan/${clientId}/brand_keyword_search?keyword=${encodeURIComponent(keyword)}`)
                .then(r => r.json())
                .then(data => {
                    matchingBrandIds = data.matching_brand_ids
                        ? new Set(data.matching_brand_ids.map(String))
                        : null;
                    filterBrands(businessCatVal, netWorthVal, liquidCapVal, regStateVal, brandNameVal, homeBasedVal, operatorVal, hoursVal, unitsOpenVal, allInVal, employeesVal, employeeTypeVal, salesSkillsVal, nonGlamorousVal, timeToOpenVal, recentlyAddedVal);
                });
        }, 300);
    });
    // -----------------------------------------------------------------------------------------------------------------

    $('#franchise-fit-plan .remove-brand-button').click(function () {
        $(this).addClass('d-none');
        $(this).closest('td').find('.remove-brand-form').removeClass('d-none');
    });

    $('#franchise-fit-plan .cancel-remove-brand-button').click(function () {
        $(this).closest('.remove-brand-form').addClass('d-none');
        $(this).closest('td').find('.remove-brand-button').removeClass('d-none');
    });

    $('#franchise-fit-plan .add-brand').click(function () {
        // Client brand planning
        const dismissedReason = $(this).find('.dismissed-reason')
        const dismissedReasonComments = dismissedReason.find('.dismissed-reason-comments')
        const dismissedButton = dismissedReason.find('.dismissed-reason-button')

        if ($(this).hasClass('add-brand-selected')) {
            $(this).removeClass('add-brand-selected');

            dismissedReasonComments.addClass('d-none')
            dismissedButton.removeClass('d-none')
            dismissedReason.removeClass('dismissed-reason-expanded')
        } else {
            $(this).addClass('add-brand-selected');

            dismissedReasonComments.removeClass('d-none')
            dismissedButton.addClass('d-none')
            dismissedReason.addClass('dismissed-reason-expanded')
        }

        let brandIds = [];
        $('#franchise-fit-plan .add-brand.add-brand-selected').each(function () {
            brandIds.push($(this).attr('brand_id'));
        });
        const brandIdsString = brandIds.join(',')
        $('#add-brands-form-field').val(brandIdsString);

        $('.submit-brands-button').text('Add ' + brandIds.length + ' Brand' + (brandIds.length === 1 ? '' : 's'))
    });

    $('#franchise-fit-plan .submit-brands-button').click(function () {
        const form = $(this).closest('form').submit();
    });

    $('#franchise-fit-plan tr .hide-territory-button').click(function () {
        const tableParent = $(this).closest('.main-fit-plan-tables-js');
        const parentTd = $(this).closest('td');
        const parentRow = $(this).closest('tr');
        const rowIndex = parentRow.index();
        const hsContactId = parentTd.attr('hs_contact_id');
        const territoryState = parentTd.attr('territory_state');
        const territoryCity = parentTd.attr('territory_city');

        $.post('/client_territory_check_locations/create_or_update', { hs_contact_id: hsContactId, territory_state: territoryState, territory_city: territoryCity, hidden: true }).done(function (data) {
            // Remove parent row from all main tables
            tableParent.find('tr:nth-child(' + (rowIndex + 1) + ')').remove();
        });
    });

    const viewMoreTChecksRow = $('#franchise-fit-plan tr.view-more-t-checks')
    const parentTable = viewMoreTChecksRow.closest('table');
    const hiddenRows = parentTable.find('.hidden-t-location')
    viewMoreTChecksRow.click(function () {
        const parentTr = $(this).closest('tr');
        const hsContactId = parentTr.attr('hs_contact_id');

        $.post('/client_territory_check_locations/unhide_all', { hs_contact_id: hsContactId }).done(function (data) {
            // Reload page
            location.reload();
        });
    });

    $('#franchise-fit-plan .fit-presenting-remote-form-button').on('mouseover', function () {
        const parent = $(this).closest('td');
        $(this).addClass('d-none');
        parent.find('.fit-presenting-remote-form').removeClass('d-none');
    });

    const fitPresentingRemoteFormSelect = $('#franchise-fit-plan .fit-presenting-remote-form-select');
    fitPresentingRemoteFormSelect.on('mouseout', function () {
        const parent = $(this).closest('td');
        parent.find('.fit-presenting-remote-form').addClass('d-none');
        parent.find('.fit-presenting-remote-form-button').removeClass('d-none');
    });
    fitPresentingRemoteFormSelect.change(function () {
        const form = $(this).closest('form');
        if (form.get(0)?.requestSubmit) {
            form.get(0).requestSubmit();
        } else {
            form.trigger('submit');
        }
        const parent = $(this).closest('td');
        parent.find('.fit-presenting-remote-form-button').text($(this).val() || 'Select Rank');
    });

    $('#franchise-fit-plan .fit-presenting-yes-no-button').click(function () {
        const currentText = $(this).text().trim();
        let nextValue = true;
        if (currentText === 'Yes') nextValue = false;
        else if (currentText === 'No') nextValue = null;
        const parent = $(this).closest('td');
        const form = parent.find('form');
        form.find('input[name=moving_forward]').val(nextValue);
        if (form.get(0)?.requestSubmit) {
            form.get(0).requestSubmit();
        } else {
            form.trigger('submit');
        }
        if (nextValue === false) $(this).removeClass('fit-presenting-yes').addClass('fit-presenting-no').text('No');
        else if (nextValue === true) $(this).removeClass('fit-presenting-no').addClass('fit-presenting-yes').text('Yes');
        else $(this).removeClass('fit-presenting-no fit-presenting-yes').text('Undecided');
    });

    $(document).on("ajax:success", ".send-to-discovery-form", function (event, response) {
        const form = $(this);
        const sendToDiscoverySuccess = form.closest('.card').find('.send-to-discovery-success');
        const responseData = response || event.detail?.[0] || {};

        if (responseData.success) {
            form.find('.send-to-discovery-submit-btn.send-required').removeClass('send-required');
            form.addClass('d-none');
            sendToDiscoverySuccess.removeClass('d-none');
            return;
        }

        sendToDiscoverySuccess.html('<h1 class="accent-red">Sorry, Something Went Wrong!</h1><h3 class="accent-red">There was an error sending the brand introduction. Refresh the page to try again, then message <a href="mailto:it@franchisesidekick.com">it@franchisesidekick.com</a> if this happens again.</h3>');
        sendToDiscoverySuccess.removeClass('d-none');
        if (responseData.error) alert(responseData.error);
    });

    $(document).on("ajax:error", ".send-to-discovery-form", function (event, xhr) {
        const form = $(this);
        const sendToDiscoverySuccess = form.closest('.card').find('.send-to-discovery-success');
        const request = xhr || event.detail?.[2] || event.detail?.[0];
        let response = {};

        try {
            response = request.responseJSON || JSON.parse(request.responseText);
        } catch (_error) {
            response = {};
        }

        sendToDiscoverySuccess.html('<h1 class="accent-red">Sorry, Something Went Wrong!</h1><h3 class="accent-red">There was an error sending the brand introduction. Refresh the page to try again, then message <a href="mailto:it@franchisesidekick.com">it@franchisesidekick.com</a> if this happens again.</h3>');
        sendToDiscoverySuccess.removeClass('d-none');
        if (response.error) alert(response.error);
    });

    $(document).on("ajax:complete", '.remove-active-brand-remote-form', function (event, xhr) {
        const request = xhr || event.detail?.[0];
        const response = request.responseJSON || JSON.parse(request.responseText);
        if (response.success) {
            // Remove brand-container, hide modal
            const brandContainer = $(this).closest('.single-brand-container');
            const removeModal = $(this).closest('.active-brand-removal-modal')
            removeModal.modal('hide');

            // Remove adjacent brand-separator
            brandContainer.next('.brand-separator').remove();

            // Remove the brand container
            brandContainer.remove()

            // Tell all client task bin components to reload
            window.reloadClientTaskBinComponents();

        } else {
            alert("Something went wrong: " + response.error);
        }
    });

    $(document).on("ajax:complete", '.remove-brand-remote-form', function (event, xhr) {
        const request = xhr || event.detail?.[0];
        const response = request.responseJSON || JSON.parse(request.responseText);
        if (response.success) {
            // Remove column. First row starts with a colspan 2 td, so index is not the same for every row.
            // The index we get is for the first row.
            const td = $(this).closest('td');
            const rowCol = td.parent().children().index(td) + 1; // Add one because nth-child is 1 based.
            const table = td.closest('table')
            table.find('tr td:nth-child(' + rowCol + ')').remove();
        } else {
            alert("Something went wrong: " + response.error);
        }
    });

    $('#franchise-fit-plan select.select-director-dropdown').change(function () {
        const parent = $(this).closest('form');
        parent.find('.book-meeting-btn').addClass('d-none');
        let meetingBtn = parent.find('.book-meeting-btn[director="' + $(this).val() + '"]');
        if (!meetingBtn.length) meetingBtn = parent.find('.book-meeting-btn[director="General"]');
        meetingBtn.removeClass('d-none');
    });

    $('.finalize-form').submit(function () {
        if ($('.send-to-discovery-submit-btn.send-required').length === 0) return true;
        else return confirm('Are you sure? Not all brand introductions have been sent. The information entered in step 2 will not be saved unless the introduction was sent.')
    });

    const sendToDiscoverySubmitBtn = $('.send-to-discovery-submit-btn');
    const clientSummarySaveBtn = $('.client-summary-save-btn');
    const step1RequiredSections = $('.step-1-required');
    const step1IncompleteSections = $('.step-1-incomplete');
    $('.client-summary-form textarea').on('input', updatedVisibleClientInfo);
    $('.client-summary-form select').change(updatedVisibleClientInfo);
    function updatedVisibleClientInfo() {
        step1RequiredSections.addClass('d-none');
        step1IncompleteSections.removeClass('d-none');
        clientSummarySaveBtn.prop('disabled', false).val('Save');
        sendToDiscoverySubmitBtn.prop('disabled', true).val('Update Client Summary First');
    }

    $(document).on('ajax:success', '.client-summary-form', function (event, response) {
        const responseData = response || event.detail?.[0] || {};

        if (responseData.success) {
            setTimeout(function () {
                clientSummarySaveBtn.prop('disabled', true).val('Saved');
                sendToDiscoverySubmitBtn.prop('disabled', false).val('Send Brand Introduction');
                step1IncompleteSections.addClass('d-none');
                step1RequiredSections.removeClass('d-none');
            }, 0);
        } else if (responseData.error) alert(responseData.error);
    });

    $(document).on('ajax:error', '.client-summary-form', function (event, response) {
        const responseData = response || event.detail?.[0] || {};
        if (responseData.error) alert(responseData.error);
    });
    $('.brand-territory-check-info-modal-js').click(function () {
        $.get(`${$(this).attr('path')}`).done(function (html) {
            const myModal = $('#brand-territory-check-info-modal')
            myModal.find('.modal-body').html(html)
            myModal.modal('show');
        });
    });
});
